(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-acc-add]').forEach(function (btn) {
      var label = btn.textContent;
      btn.addEventListener('click', function () {
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js').then(function (c) { return c.json(); }); })
          .then(function (cart) {
            btn.classList.add('is-done');
            btn.textContent = btn.dataset.done;
            var link = btn.parentNode.querySelector('[data-acc-cart]');
            if (link) link.hidden = false;
            var cartLink = document.querySelector('.header__cart');
            if (cartLink) {
              var badge = cartLink.querySelector('.header__cart-count');
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'header__cart-count';
                badge.setAttribute('aria-hidden', 'true');
                cartLink.appendChild(badge);
              }
              badge.textContent = cart.item_count;
            }
            if (window.PlayCart && window.PlayCart.open) window.PlayCart.open();
            setTimeout(function () {
              btn.classList.remove('is-done');
              btn.textContent = label;
              btn.disabled = false;
            }, 2500);
          })
          .catch(function () {
            btn.textContent = 'Опитай отново';
            btn.disabled = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // window.PlayCart.open() / .close() / .refresh() for the cart drawer.
  (function () {
    var PC = window.PlayCart = window.PlayCart || {};
    if (PC.drawerBound) return;
    PC.drawerBound = true;

    var lastFocus = null;
    function drawer() { return document.querySelector('[data-cart-drawer]'); }

    function updateBadge(count) {
      var link = document.querySelector('.header__cart');
      if (!link) return;
      var badge = link.querySelector('.header__cart-count');
      if (!count) { if (badge) badge.remove(); return; }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'header__cart-count';
        badge.setAttribute('aria-hidden', 'true');
        link.insertBefore(badge, link.firstChild);
      }
      badge.textContent = count;
    }

    // Fresh contents from the same Liquid as the cart page.
    PC.refresh = function () {
      var el = drawer();
      if (!el) return Promise.resolve();
      el.classList.add('is-loading');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = new DOMParser().parseFromString(data['cart-drawer'] || '', 'text/html');
          var fresh = html.querySelector('[data-cart-drawer-inner]');
          var current = el.querySelector('[data-cart-drawer-inner]');
          if (fresh && current) current.replaceWith(fresh);
          updateBadge(parseInt(fresh ? fresh.dataset.cartCount : '0', 10) || 0);
          if (PC.cleanOrphans) PC.cleanOrphans(el.querySelector('[data-cart-contents]'));
        })
        .catch(function (err) { console.error('Cart drawer refresh failed:', err); })
        .then(function () { el.classList.remove('is-loading'); });
    };

    PC.open = function () {
      var el = drawer();
      if (!el) { window.location.href = '/cart'; return; }
      lastFocus = document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var panel = el.querySelector('.cart-drawer__panel');
      if (panel) panel.focus({ preventScroll: true });
      return PC.refresh();
    };

    PC.close = function () {
      var el = drawer();
      if (!el || !el.classList.contains('is-open')) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-cart-drawer-close]')) { e.preventDefault(); PC.close(); return; }
      // Header cart icon opens the drawer, except on the cart page itself.
      var cartLink = e.target.closest('.header__cart');
      if (cartLink && !document.body.classList.contains('template-cart') && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault();
        PC.open();
      }
    });

    // Checkout: the courier middleware takes the click on the drawer's name="checkout" button
    // (document capture). This runs first (window capture) and only closes the drawer.
    window.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-cart-drawer] [data-cart-checkout]')) {
        setTimeout(PC.close, 0);
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') PC.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // "Добави в количката" on the wooden stand card: add 1, confirm, update the header badge.
  (function () {
    document.querySelectorAll('[data-stand-add]').forEach(function (btn) {
      var label = btn.textContent;
      btn.addEventListener('click', function () {
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js').then(function (c) { return c.json(); }); })
          .then(function (cart) {
            btn.classList.add('is-done');
            btn.textContent = btn.dataset.done;
            var link = document.querySelector('.header__cart');
            if (link) {
              var badge = link.querySelector('.header__cart-count');
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'header__cart-count';
                badge.setAttribute('aria-hidden', 'true');
                link.appendChild(badge);
              }
              badge.textContent = cart.item_count;
            }
            if (window.PlayCart && window.PlayCart.open) window.PlayCart.open();
            setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; btn.disabled = false; }, 2500);
          })
          .catch(function () { btn.textContent = label; btn.disabled = false; });
      });
    });
  })();

  (function () {
    // Only these values are carried over; anything else is ignored.
    var params = new URLSearchParams(window.location.search);
    var note = document.querySelector('[data-collection-choice]');
    var carry = new URLSearchParams();
    // ?gift=1 only counts while the gift set is in stock (theme settings → Добавки към магнит).
    if (params.get('gift') === '1' && note && note.hasAttribute('data-gift-available')) carry.set('gift', '1');
    var qty = params.get('qty');
    if (qty === '2' || qty === '3' || qty === '4') carry.set('qty', qty);
    if (!carry.toString()) return;

    document.querySelectorAll('.collection-page .product-card[href]').forEach(function (link) {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      carry.forEach(function (value, key) { url.searchParams.set(key, value); });
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });

    if (!note) return;
    var parts = [];
    if (carry.get('gift')) parts.push(note.dataset.gift);
    if (carry.get('qty')) parts.push(note.dataset.qty.replace('__N__', carry.get('qty')));
    note.querySelector('[data-collection-choice-text]').textContent = note.dataset.template.replace('__CHOICE__', parts.join(' · '));
    var clear = new URL(window.location.href);
    clear.searchParams.delete('gift');
    clear.searchParams.delete('qty');
    note.querySelector('[data-collection-choice-clear]').setAttribute('href', clear.pathname + clear.search);
    note.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.faq__item');
      var isOpen = item.classList.contains('faq__item--open');

      document.querySelectorAll('.faq__item').forEach(function (el) {
        el.classList.remove('faq__item--open');
        el.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
        el.querySelector('.faq__answer').setAttribute('aria-hidden', 'true');
      });

      if (!isOpen) {
        item.classList.add('faq__item--open');
        this.setAttribute('aria-expanded', 'true');
        item.querySelector('.faq__answer').setAttribute('aria-hidden', 'false');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Dark theme switch. The initial theme is applied by a small script in the layout
  // <head> (before first paint); this only syncs the switch and handles clicks.
  (function () {
    var root = document.documentElement;
    var switches = document.querySelectorAll('[data-theme-toggle]');
    if (!switches.length) return;

    function sync() {
      var dark = root.getAttribute('data-theme') === 'dark';
      switches.forEach(function (s) { s.setAttribute('aria-checked', dark ? 'true' : 'false'); });
    }

    switches.forEach(function (s) {
      s.addEventListener('click', function () {
        var dark = root.getAttribute('data-theme') !== 'dark';
        if (dark) root.setAttribute('data-theme', 'dark');
        else root.removeAttribute('data-theme');
        try { localStorage.setItem('ptn-theme', dark ? 'dark' : 'light'); } catch (e) {}
        sync();
      });
    });

    // Until the visitor picks a theme themselves, keep following the device setting
    // (e.g. phones that switch to dark mode at sunset).
    var mq = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    if (mq && mq.addEventListener) {
      mq.addEventListener('change', function (e) {
        var saved = null;
        try { saved = localStorage.getItem('ptn-theme'); } catch (err) {}
        if (saved) return;
        if (e.matches) root.setAttribute('data-theme', 'dark');
        else root.removeAttribute('data-theme');
        sync();
      });
    }
    sync();
  })();

  (function () {
    var toggle   = document.querySelector('.header__menu-toggle');
    var drawer   = document.getElementById('nav-drawer');
    var backdrop = document.getElementById('nav-backdrop');
    if (!toggle || !drawer) return;

    var focusableSelectors = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('.nav-drawer__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }

    toggle.addEventListener('click', function () {
      toggle.getAttribute('aria-expanded') === 'true' ? closeDrawer() : openDrawer();
    });

    var closeBtn = drawer.querySelector('.nav-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = Array.from(drawer.querySelectorAll(focusableSelectors));
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('.nav-drawer__link')) closeDrawer();
    });

    var header = document.querySelector('.header');
    if (header) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('scrolled', window.scrollY > 50);
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      var video = root.querySelector('[data-hiw-video]');
      var toggle = root.querySelector('[data-hiw-toggle]');
      var media = video && video.parentNode;
      if (!video || !toggle || video.dataset.hiwReady) return;
      video.dataset.hiwReady = 'true';

      // A pause from the button sticks; scrolling away and back only resumes videos the
      // visitor didn't stop themselves.
      var userPaused = reduceMotion;

      function load() {
        if (!video.getAttribute('src')) {
          video.src = video.dataset.src;
          video.preload = 'auto';
        }
      }

      function setPlaying(playing) {
        media.setAttribute('data-hiw-playing', playing ? 'true' : 'false');
        toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
      }

      function play() {
        load();
        video.muted = true; // required for autoplay on iOS/Chrome
        var p = video.play();
        // Autoplay can still be refused (e.g. iOS Low Power Mode): show the play button.
        if (p && p.catch) p.catch(function () { setPlaying(false); });
      }

      video.addEventListener('play', function () { setPlaying(true); });
      video.addEventListener('pause', function () { setPlaying(false); });

      toggle.addEventListener('click', function () {
        if (video.paused) { userPaused = false; play(); }
        else { userPaused = true; video.pause(); }
      });

      if (!('IntersectionObserver' in window)) {
        if (userPaused) load(); else play();
        return;
      }

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (userPaused) load(); else play();
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { rootMargin: '200px 0px' }).observe(video);
    }

    document.querySelectorAll('[data-hiw]').forEach(init);
    // Theme editor re-renders the section without a page load.
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-hiw]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CLOUDINARY = 'https://api.cloudinary.com/v1_1/dofrdcvke/image/upload';
    var MAX_PHOTO = 10 * 1024 * 1024;

    function init(root) {
      if (!root || root.dataset.rfReady) return;
      root.dataset.rfReady = 'true';
      var form = root.querySelector('form');
      var errorEl = root.querySelector('[data-rf-error]');
      var submitBtn = root.querySelector('[data-rf-submit]');
      var photoInput = root.querySelector('[data-rf-photo]');
      var photoStatus = root.querySelector('[data-rf-photo-status]');
      var photoUrl = '';
      var photoPending = null;

      function showError(msg) {
        errorEl.textContent = msg || '';
        errorEl.hidden = !msg;
      }

      var cropper = root.querySelector('[data-rf-cropper]');
      var frame = root.querySelector('[data-rf-crop-frame]');
      var cropImg = root.querySelector('[data-rf-crop-img]');
      var zoomInput = root.querySelector('[data-rf-zoom]');
      var preview = root.querySelector('[data-rf-preview]');
      var previewImg = root.querySelector('[data-rf-preview-img]');
      var crop = null; // { size, base, scale, x, y } while the cropper is open
      var objectUrls = [];

      function trackUrl(url) { objectUrls.push(url); return url; }
      function releaseUrls() { objectUrls.forEach(URL.revokeObjectURL); objectUrls = []; }

      function upload(blob) {
        photoStatus.textContent = root.getAttribute('data-msg-photo-uploading');
        var fd = new FormData();
        fd.append('file', blob);
        fd.append('upload_preset', 'playthenow');
        photoPending = fetch(CLOUDINARY, { method: 'POST', body: fd })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (!d.secure_url) throw new Error((d.error && d.error.message) || 'upload failed');
            photoUrl = d.secure_url;
            photoStatus.textContent = root.getAttribute('data-msg-photo-done');
          })
          .catch(function () {
            resetPhoto();
            photoStatus.textContent = root.getAttribute('data-msg-photo-failed');
          })
          .finally(function () { photoPending = null; });
      }

      function resetPhoto() {
        photoUrl = '';
        crop = null;
        photoInput.value = '';
        photoInput.hidden = false;
        cropper.hidden = true;
        preview.hidden = true;
        photoStatus.textContent = '';
        releaseUrls();
      }

      // Keep the image covering the square frame.
      function place() {
        var w = cropImg.naturalWidth * crop.scale;
        var h = cropImg.naturalHeight * crop.scale;
        crop.x = Math.min(0, Math.max(crop.size - w, crop.x));
        crop.y = Math.min(0, Math.max(crop.size - h, crop.y));
        cropImg.style.transform = 'translate(' + crop.x + 'px,' + crop.y + 'px) scale(' + crop.scale + ')';
      }

      function openCropper() {
        photoInput.hidden = true;
        cropper.hidden = false;
        var size = frame.clientWidth;
        var base = Math.max(size / cropImg.naturalWidth, size / cropImg.naturalHeight);
        crop = { size: size, base: base, scale: base };
        crop.x = (size - cropImg.naturalWidth * base) / 2;
        crop.y = (size - cropImg.naturalHeight * base) / 2;
        zoomInput.value = 1;
        place();
      }

      photoInput.addEventListener('change', function () {
        var file = photoInput.files && photoInput.files[0];
        photoUrl = '';
        releaseUrls();
        if (!file) { photoStatus.textContent = ''; return; }
        cropImg.onload = openCropper;
        cropImg.onerror = function () {
          // The browser can't show this format (e.g. HEIC outside Safari): upload it uncropped.
          if (file.size > MAX_PHOTO) {
            resetPhoto();
            photoStatus.textContent = root.getAttribute('data-msg-photo-big');
            return;
          }
          upload(file);
        };
        cropImg.src = trackUrl(URL.createObjectURL(file));
      });

      zoomInput.addEventListener('input', function () {
        if (!crop) return;
        // Zoom around the centre of the frame.
        var cx = (crop.size / 2 - crop.x) / crop.scale;
        var cy = (crop.size / 2 - crop.y) / crop.scale;
        crop.scale = crop.base * Number(zoomInput.value);
        crop.x = crop.size / 2 - cx * crop.scale;
        crop.y = crop.size / 2 - cy * crop.scale;
        place();
      });

      var drag = null;
      frame.addEventListener('pointerdown', function (e) {
        if (!crop) return;
        drag = { id: e.pointerId, x: e.clientX - crop.x, y: e.clientY - crop.y };
        try { frame.setPointerCapture(e.pointerId); } catch (err) {}
      });
      frame.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        crop.x = e.clientX - drag.x;
        crop.y = e.clientY - drag.y;
        place();
      });
      function endDrag() { drag = null; }
      frame.addEventListener('pointerup', endDrag);
      frame.addEventListener('pointercancel', endDrag);

      root.querySelector('[data-rf-crop-cancel]').addEventListener('click', resetPhoto);
      root.querySelector('[data-rf-photo-change]').addEventListener('click', function () {
        resetPhoto();
        photoInput.click();
      });

      root.querySelector('[data-rf-crop-ok]').addEventListener('click', function () {
        var side = crop.size / crop.scale; // visible square, in original pixels
        var out = Math.round(Math.min(1200, side));
        var canvas = document.createElement('canvas');
        canvas.width = out;
        canvas.height = out;
        canvas.getContext('2d').drawImage(cropImg, -crop.x / crop.scale, -crop.y / crop.scale, side, side, 0, 0, out, out);
        canvas.toBlob(function (blob) {
          cropper.hidden = true;
          crop = null;
          previewImg.src = trackUrl(URL.createObjectURL(blob));
          preview.hidden = false;
          upload(blob);
        }, 'image/jpeg', 0.9);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        showError('');
        var data = new FormData(form);
        if (!data.get('rating')) return showError(root.getAttribute('data-msg-rating'));
        if (!String(data.get('name') || '').trim()) return showError(root.getAttribute('data-msg-name'));
        if (!form.email.checkValidity() || !data.get('email')) return showError(root.getAttribute('data-msg-email'));
        if (crop) return showError(root.getAttribute('data-msg-photo-confirm'));

        submitBtn.disabled = true;
        submitBtn.textContent = root.getAttribute('data-msg-sending');
        (photoPending || Promise.resolve())
          .then(function () {
            if (!String(data.get('body') || '').trim() && !photoUrl) {
              throw new Error(root.getAttribute('data-msg-empty'));
            }
            return fetch(root.dataset.endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                name: data.get('name'),
                email: data.get('email'),
                rating: Number(data.get('rating')),
                title: data.get('title'),
                body: data.get('body'),
                photo: photoUrl,
                website: data.get('website'),
              }),
            }).then(function (r) {
              return r.json().then(function (d) {
                if (!r.ok || !d.ok) throw new Error(d.error || root.getAttribute('data-msg-failed'));
                return d;
              });
            });
          })
          .then(function () {
            form.hidden = true;
            root.querySelector('[data-rf-done]').hidden = false;
          })
          .catch(function (err) {
            showError(err && err.message ? err.message : root.getAttribute('data-msg-failed'));
            submitBtn.disabled = false;
            submitBtn.textContent = root.getAttribute('data-msg-submit');
          });
      });
    }

    document.querySelectorAll('[data-review-form]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('[data-review-form]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var track = document.getElementById('reviews-track');
    var fade = document.getElementById('reviews-fade');
    var arrow = document.getElementById('reviews-arrow');

    var dotsWrap = document.getElementById('reviews-dots');

    if (!track || !fade || !arrow) return;

    var cards = track.querySelectorAll('.review-card');
    var dots = [];

    function cardLeft(i) {
      return cards[i].offsetLeft - cards[0].offsetLeft;
    }

    // The card nearest the left edge; at the end of the track that's the last one.
    function activeIndex(atEnd) {
      if (atEnd) return cards.length - 1;
      var best = 0;
      for (var i = 1; i < cards.length; i++) {
        if (Math.abs(cardLeft(i) - track.scrollLeft) < Math.abs(cardLeft(best) - track.scrollLeft)) best = i;
      }
      return best;
    }

    if (dotsWrap && cards.length > 1) {
      var label = dotsWrap.getAttribute('data-label');
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'reviews__dot';
        dot.setAttribute('aria-label', label + ' ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: cardLeft(i), behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
      dotsWrap.hidden = false;
    }

    function updateIndicators() {
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      fade.style.opacity = atEnd ? '0' : '1';
      arrow.style.opacity = atEnd ? '0' : '1';
      var active = activeIndex(atEnd);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    }

    track.addEventListener('scroll', updateIndicators, { passive: true });
    updateIndicators();

    // Nudge the cards once when the slider first comes into view, to show it can be swiped.
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion && 'IntersectionObserver' in window && track.scrollWidth > track.clientWidth + 4) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        if (activeIndex(false) !== 0) return; // already swiped
        track.classList.add('is-nudging');
        track.addEventListener('animationend', function () {
          track.classList.remove('is-nudging');
        }, { once: true });
      }, { threshold: 0.6 });
      io.observe(track);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
